// React Lazily
import { lazily } from 'react-lazily'

// Interfaces
import { IRoute } from 'routes/route.interface'

// Constant
import { CONTENT_URL, CONTENT_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ContentHomeIndex } = lazily(() => import('pages/back-office/content-management/home'))

const contentHomepageRoutes: IRoute[] = [
  {
    path: CONTENT_URL.HOMEPAGE,
    component: ContentHomeIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: CONTENT_MODULE,
      requireAuth: true,
      attrs: {
        label: 'contentManagementHome.home',
        accessCodes: [552],
      },
    },
  },
]

export { contentHomepageRoutes }
